<template>
  <div id="OrgViewCooperation">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业往来</span>
      </eb-panel-header>
      <div slot="body">
        <ebHandsontableView :hotSettings="orgCooperationHotSettings" class="panel-handsontable" />
        <eb-pagination :current-page.sync="pageNumber" v-if="paginationSize" @current-change="paginationData" :total="paginationSize"
        />

      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebHandsontableView from '@/components/common/eb-handsontable-view';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { listHistory } from '@/services/user/user-supplier-service';
export default {
  props: {
    orgCooperation: {
      type: Object,
      required: true
    }
  },
  components: {
    ebPanel,
    ebPanelHeader,
    ebHandsontableView,
    ebPagination
  },
  watch: {
    orgCooperation(newVal) {
      this.listRequestData.buyDepartId = newVal.buyerId;
      this.listRequestData.supDepartId = newVal.supplierId;
      this.initOrgCooperation();
    }
  },
  data() {
    return {
      paginationSize: null,
      listRequestData: {
        length: 10,
        start: 1,
        buyDepartId: this.orgCooperation.buyerId,
        supDepartId: this.orgCooperation.supplierId
      },
      pageNumber: 1,
      orgCooperationHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['报价日期', '项目名称', '项目金额', '形式', '类别', '中选情况'],
        renderAllRows: true,
        fillHandle: false,
        rowHeaderWidth: 40,
        data: [],
        columns: [
          {
            data: 'createTime',
            type: 'text',
            width: 200,
            readOnly: true
          },
          {
            data: 'projectName',
            type: 'text',
            width: 300,
            readOnly: true
          },
          {
            data: 'quoteMin',
            width: 140,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            readOnly: true
          },
          {
            data: 'projectMethod',
            type: 'text',
            width: 100,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'projectType',
            type: 'text',
            width: 100,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'quoteStatus',
            type: 'text',
            width: 100,
            className: 'htCenter',
            readOnly: true
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    // 查询历史合作
    async initOrgCooperation() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listHistory(this.listRequestData);
        if (data.returnCode === '01') {
          this.orgCooperationHotSettings.data = this.changeHotData(data.data);
          this.paginationSize = data.recordsTotal;
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('获取企业往来失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 点击分页
    paginationData: function(data) {
      this.listRequestData.start = data;
      this.initOrgCooperation();
    },
    changeHotData: function(hotData) {
      if (hotData != null) {
        for (var i = 0; i < hotData.length; i++) {
          hotData[i].createTime = this.$options.filters['dateTimeStandardFormat'](hotData[i].createTime);
          hotData[i].projectType = this.$options.filters['projectType'](hotData[i].projectType);
          hotData[i].projectMethod = this.$options.filters['projectMethod'](hotData[i].projectMethod);
          var quoteStatus = hotData[i].quoteStatus;
          if (quoteStatus === '6') {
            hotData[i].quoteStatus = '中选';
          } else {
            hotData[i].quoteStatus = '报价';
          }
        }
      }
      return hotData;
    }
  }
};
</script>

<style>
</style>
